import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ItemsQuickListComponent } from "./items-quick-list.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButtonModule } from "@angular/material/button";
import { SharedPipesModule } from "src/app/shared/pipes/shared-pipes.module";
import { MatSortModule } from "@angular/material/sort";
import { MatInputModule } from "@angular/material/input";
import { ReactiveFormsModule } from "@angular/forms";
import { ItemInventoryCodeModule } from "../item-inventory-code/item-inventory-code.module";
import { ItemOpenInNewButtonComponent } from "../item-open-in-new-button/item-open-in-new-button.component";
import { ItemGoToDetailButtonComponent } from "../item-go-to-detail-button/item-go-to-detail-button.component";
import { ItemsExportButtonComponent } from "../items-export-button/items-export-button.component";

@NgModule({
  declarations: [ItemsQuickListComponent],
  imports: [
    CommonModule,
    SharedPipesModule,
    MatDialogModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatInputModule,
    ReactiveFormsModule,
    ItemInventoryCodeModule,
    ItemOpenInNewButtonComponent,
    ItemGoToDetailButtonComponent,
    ItemsExportButtonComponent,
  ],
  exports: [ItemsQuickListComponent],
})
export class ItemsQuickListModule {}
